import React from "react";

const PerpetualButtons = ({
  currentTexts,
  setCurrentTexts,
  setSuportingAC,
  closingCircle,
  setClosingCircle,
}) => (
  <div className="buttonsSection">
    <div className="buttonsSection__grid">
      <div className="buttonsSection__col">
        <div
          className={`buttonLink mb-3 ${currentTexts === 1 ? "active" : ""}`}
        >
          <h1 className="Candara link" onClick={() => setCurrentTexts(1)}>
            RO entering the EU
          </h1>
        </div>
        <div
          className={`buttonLink mb-3 ${currentTexts === 2 ? "active" : ""}`}
        >
          <h1 className="Candara link" onClick={() => setSuportingAC(true)}>
            Alongside AC
          </h1>
        </div>
      </div>
      <div className="buttonsSection__col">
        <div
          className={`buttonLink mb-3 ${currentTexts === 6 ? "active" : ""}`}
        >
          <h1 className="Candara link mr-2" onClick={() => setCurrentTexts(6)}>
            LMH Scholarship
          </h1>
          <div className="p-0 m-0" id="circle"></div>
        </div>
        <div className={`buttonLink mb-3 ${closingCircle ? "active" : ""}`}>
          <h1
            className="Candara link mr-2"
            onClick={() => setClosingCircle(true)}
          >
            Closing the circle
          </h1>
          <div className="p-0 m-0" id="circle"></div>
        </div>
      </div>
      <div className="buttonsSection__col">
        <div
          className={`buttonLink mb-3 ${currentTexts === 5 ? "active" : ""}`}
        >
          <h1 className="Candara link" onClick={() => setCurrentTexts(5)}>
            Videos
          </h1>
        </div>
        <div
          className={`buttonLink mb-3 ${currentTexts === 7 ? "active" : ""}`}
        >
          <h1 className="Candara link" onClick={() => setCurrentTexts(7)}>
            Acknowledgements
          </h1>
        </div>
      </div>
    </div>
  </div>
);

export default PerpetualButtons;
